/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class SlideoutAPI
 * @hideconstructor
 * @classdesc Internal API class that is used to manage the properties API.
 */
define([], () => {
	class PropertiesPaneAPI {

		/**
		 * @function PropertiesPaneAPI#getProviderId
		 * @description Get the provider id of the properties feature
		 * @return {String}
		 */
		getProviderId() {}
	}

	return PropertiesPaneAPI;
});